export default __webpack_public_path__ + "static/media/sidebar-positions.5331a949.svg";